import * as React from 'react';
import { serverErrorsHandler } from '@wix/thunderbolt-elements/src/components/SiteMembersInput/viewer/utils';
import type { ITranslationKeys } from '@wix/thunderbolt-elements/src/components/SiteMembersInput/SiteMembersInput.types';

type IUseSocialErrorHandler = (
  translations: ITranslationKeys,
  socialErrorMsg?: string,
) => [
  string,
  (error: any) => void,
  <TCallback extends (...args: Array<any>) => any>(
    cb: TCallback,
  ) => (...args: Parameters<TCallback>) => ReturnType<TCallback>,
];

export const getResetSocialAuthError =
  (resetFn: () => void) =>
  <TCallback extends (...args: Array<any>) => any>(cb: TCallback) =>
  (...args: Parameters<TCallback>) => {
    resetFn();
    return cb(...args) as ReturnType<TCallback>;
  };

export const useSocialErrorHandler: IUseSocialErrorHandler = (
  translations,
  socialErrorMsg = '',
) => {
  const [socialAuthError, setSocialAuthError] = React.useState(socialErrorMsg);
  const translateAndSetSocialAuthError = (error: any) => {
    const errorMsg = serverErrorsHandler(error);
    const defaultErrorMsg = translations.membersErrorGeneral!;
    setSocialAuthError(translations[errorMsg] ?? defaultErrorMsg);
  };
  const resetSocialAuthError = getResetSocialAuthError(() =>
    setSocialAuthError(''),
  );
  return [
    socialAuthError,
    translateAndSetSocialAuthError,
    resetSocialAuthError,
  ];
};
